import * as Types from '../types/graphql.gen';

import { gql } from '@apollo/client';
export type LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationLoginCompletedFragment = { __typename?: 'LoginNavigationLoginCompleted', redirectTo?: string | null };

export type LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireChangeDefaultPasswordFragment = { __typename?: 'LoginNavigationRequireChangeDefaultPassword', redirectTo?: string | null };

export type LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireMfaMethodSelectionFragment = { __typename?: 'LoginNavigationRequireMFAMethodSelection', redirectTo?: string | null };

export type LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireMfaRecoveryFragment = { __typename?: 'LoginNavigationRequireMFARecovery', redirectTo?: string | null };

export type LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireSmsAuthenticationFragment = { __typename?: 'LoginNavigationRequireSMSAuthentication', redirectTo?: string | null };

export type LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireSmsRecoveryFragment = { __typename?: 'LoginNavigationRequireSMSRecovery', redirectTo?: string | null };

export type LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireTotpAuthenticationFragment = { __typename?: 'LoginNavigationRequireTOTPAuthentication', redirectTo?: string | null };

export type LoginNavigationUseHandleLoginNavigationLoginNavigationFragment = LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationLoginCompletedFragment | LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireChangeDefaultPasswordFragment | LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireMfaMethodSelectionFragment | LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireMfaRecoveryFragment | LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireSmsAuthenticationFragment | LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireSmsRecoveryFragment | LoginNavigationUseHandleLoginNavigationLoginNavigationLoginNavigationRequireTotpAuthenticationFragment;

export const LoginNavigationUseHandleLoginNavigationLoginNavigationFragmentDoc = gql`
    fragment LoginNavigation_UseHandleLoginNavigation_LoginNavigation on LoginNavigation {
  ... on LoginNavigationLoginCompleted {
    redirectTo
  }
  ... on LoginNavigationRequireChangeDefaultPassword {
    redirectTo
  }
  ... on LoginNavigationRequireMFAMethodSelection {
    redirectTo
  }
  ... on LoginNavigationRequireMFARecovery {
    redirectTo
  }
  ... on LoginNavigationRequireSMSAuthentication {
    redirectTo
  }
  ... on LoginNavigationRequireSMSRecovery {
    redirectTo
  }
  ... on LoginNavigationRequireTOTPAuthentication {
    redirectTo
  }
}
    `;

/**
 * Alias (prefix removed)
 */
export type LoginNavigation = LoginNavigationUseHandleLoginNavigationLoginNavigationFragment
export const LoginNavigationFragmentDoc = LoginNavigationUseHandleLoginNavigationLoginNavigationFragmentDoc

